import { ALTERAR_REGISTROS_POR_PAGINA_AGENCIA } from '../types'

export default function alterarRegistrosPorPaginaAgencia (valor) {
  return {
    type: ALTERAR_REGISTROS_POR_PAGINA_AGENCIA,
    payload: valor
  }
}
